import { createRoot } from "react-dom/client";
import { flushSync } from "react-dom";
import { SvgOverlay } from "components/SmartSurveyor/ReviewPage/FloorPlanPanelNew/SvgOverlay";
import {
  REFERENCE_IMAGE_SIZE,
  MIN_CIRCLE_SIZE_SCALE,
} from "components/SmartSurveyor/ReviewPage/FloorPlanPanelNew/constants";
import { ZOOM_OPACITY_THRESHOLD } from "components/features/ProgressReportViewer/utils";
import type { RenderOverlaySvgString } from "./types";

const EXPORT_ZOOM_LEVEL = 1;

export const renderOverlaySvgString: RenderOverlaySvgString = ({
  pdfPageWidth,
  pdfPageHeight,
  pixelWidth,
  pixelHeight,
  detectedObjects,
  selectedObject,
  circuitPaths,
  polygonsOverlay,
}) => {
  const circleSizeScale = Math.max(
    Math.min(pdfPageWidth, pdfPageHeight) / REFERENCE_IMAGE_SIZE,
    MIN_CIRCLE_SIZE_SCALE,
  );

  const detachedContainer = document.createElement("div");
  const root = createRoot(detachedContainer);

  try {
    flushSync(() => {
      root.render(
        <SvgOverlay
          objects={detectedObjects}
          selectedObject={selectedObject}
          backgroundObjects={undefined}
          zoomLevel={EXPORT_ZOOM_LEVEL}
          maxZoom={EXPORT_ZOOM_LEVEL}
          panOffset={{ x: 0, y: 0 }}
          circuitPaths={circuitPaths}
          floorPlanCablePaths={undefined}
          routeCreationOverlay={null}
          polygonsOverlay={polygonsOverlay}
          shouldAnimateTransition={false}
          circleSizeScale={circleSizeScale}
          opacityThreshold={ZOOM_OPACITY_THRESHOLD}
        />,
      );
    });

    const svgElement = detachedContainer.querySelector("svg");
    if (!svgElement) {
      throw new Error("SVG element not found in render output");
    }

    svgElement.setAttribute("xmlns", "http://www.w3.org/2000/svg");
    svgElement.setAttribute("viewBox", `0 0 ${pdfPageWidth} ${pdfPageHeight}`);
    svgElement.setAttribute("width", String(pixelWidth));
    svgElement.setAttribute("height", String(pixelHeight));

    return new XMLSerializer().serializeToString(svgElement);
  } finally {
    root.unmount();
  }
};
